import { http, URL } from "./http.service";
import { errorHandler } from "./error.service";
export const fetchAnswer = async (businessId, query) => {
  try {
    const resp = await http.get(`${URL}/python/chat/${businessId}`, {
      params: { q: query },
      headers: {
        "Content-Type": "application/json",
      },
    });
    return resp.data.answer;
  } catch (error) {
    console.error("Error fetching answer:", error);
    errorHandler(error); // Make sure you have this errorHandler defined
    throw error; // Re-throw if you want components to handle it
  }
};


export const createSale = async (bussinessUuid, payload) => {
  try {
    let resp = await http.post(`${URL}/sale/${bussinessUuid}/create`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return resp;
  } catch (error) {
    console.error("Error:", error);
    errorHandler(error);
  }
};


export const getSales = async (bussinessUuid, params = {}) => {
  try {
    const queryString = new URLSearchParams(params).toString();
    let resp = await http.get(`${URL}/sale/${bussinessUuid}/get-sales?${queryString}`);
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};
// export const getSales = async (bussinessUuid) => {
//   try {
//     let resp = await http.get(`${URL}/sale/${bussinessUuid}/get-sales`);
//     return resp;
//   } catch (error) {
//     errorHandler(error);
//   }
// };

// export const getOneSellData = async (customerId) => {
//   console.log("customer Id", customerId);
//   try {
//     const result = await http.get(`${URL}/sale/${customerId}`);
//     return result;
//   } catch (error) {
//     console.log("errror", error);
//     return error;
//   }
// };

export const getSalesData = async (bussinessUuid, customerId) => {
  try {
    const response = await http.get(
      `${URL}/sale/${bussinessUuid}/${customerId}`
    );
    return response.data;
  } catch (error) {
    throw new Error(`Error fetching sales data: ${error.message}`);
  }
};
export const getOneCustomer = async (bussinessUuid, customerId) => {
  // console.log("customer Id", customerId);
  try {
    const result = await http.get(`${URL}/sale/${bussinessUuid}/${customerId}`);
    return result;
  } catch (error) {
    console.log("errror", error);
    return error;
  }
};

export const updateSaleService = async (bussinessUuid, saleId, data) => {
  // console.log("data updateSaleService", data);
  try {
    return await http.put(`${URL}/sale/${bussinessUuid}/${saleId}`, data);
  } catch (error) {
    return error;
  }
};
export const deleteSaleService = async (bussinessUuid, saleId) => {
  try {
    return await http.delete(`${URL}/sale/${bussinessUuid}/${saleId}`);
  } catch (error) {
    return error;
  }
};

export const delivarydata =async(bussinessUuid)=>{
  try {
    return await http.get(`${URL}/sale/${bussinessUuid}/deliverydata`);
  } catch (error) {
    return error;
  }
}
export const verifyGSTService = async (gstin) => {
  try {
    const resp = await http.get(
      `${URL}/gst/verify/${gstin}`
    );
    return resp;
  } catch (error) {
    errorHandler(error);
  }
}